/**
 * Truncates an HTML string so that the total text content does not exceed maxLength,
 * while preserving valid HTML structure and tags.
 */
export function truncateHtmlToTextLength(html: string, maxLength: number): string {
  if (maxLength <= 0) return '';
  if (!html) return '';

  const parser = new DOMParser();
  const doc = parser.parseFromString(`<body>${html}</body>`, 'text/html');
  const container = doc.body;

  let currentLength = 0;

  function walk(node: Node): boolean {
    if (currentLength >= maxLength) {
      return false;
    }

    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.textContent || '';
      if (currentLength + text.length > maxLength) {
        const allowed = maxLength - currentLength;
        node.textContent = text.slice(0, allowed);
        currentLength = maxLength;
        return false;
      } else {
        currentLength += text.length;
        return currentLength < maxLength;
      }
    }

    const children = Array.from(node.childNodes);
    for (let i = 0; i < children.length; i++) {
      const child = children[i];
      if (currentLength >= maxLength) {
        child.parentNode?.removeChild(child);
        continue;
      }
      const canContinue = walk(child);
      if (!canContinue) {
        // Remove all remaining children in this element after reaching the limit
        for (let j = i + 1; j < children.length; j++) {
          children[j].parentNode?.removeChild(children[j]);
        }
        return false;
      }
    }
    return currentLength < maxLength;
  }

  walk(container);
  return container.innerHTML;
}
